import { FieldEditorProps } from './FieldEditorProps';
import AsyncSelect from 'Shared/components/AsyncSelect'
import '../styles/Editors.scoped.scss';

export const SurveyFieldEditor = ({ field, onChange }: FieldEditorProps) => {
  const questionId = field?.questionId
  const campaignId = field?.config?.campaignId

  return <>
    <div className="field-editor-row">
      <label>Campaign</label>
      <div className='field-editor-input'>
        <AsyncSelect
          entity="campaign"
          queryParameters={{ hasSurvey: 'y', excludeDraft: 'y' }}
          value={campaignId}
          rootClassName="grow"
          onChange={(id) => onChange({ config: { ...field.config, campaignId: id } })}
        />
      </div>
    </div>
    {(campaignId || questionId) && 
      <div className="field-editor-row">
        <label>Question</label>
        <div className="field-editor-input">
          <AsyncSelect
            entity="question"
            value={questionId}
            rootClassName="grow"
            onChange={(id) => onChange({ questionId: id })}
            queryParameters={{ campaignId: campaignId }}
          />
        </div>
      </div>
    }
  </>
}
